import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';

interface CountryFlagProps {
  countryCode: string; // e.g., "US", "fr", "DE"
  className?: string;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({ countryCode, className }) => {
  // Ensure the code is uppercase to match the library exports
  const upperCode = countryCode.toUpperCase();
  
  // Access the specific flag component from the imported object
  const FlagComponent = Flags[upperCode as keyof typeof Flags];

  // Fallback fallback if the country code is invalid or missing
  if (!FlagComponent) {
    return <span>🏳️</span>; 
  }

  return <FlagComponent className={className} />;
};
